
<template  minapp='mpx' xlang='wxml'>
<view class="card-main">
  <view class="refund">
    <image
      class="img"
      src="https://pt-starimg.didistatic.com/static/starimg/img/tpmylUP53m1652434050989.png"
    ></image>
    <view class="refund-info" wx:if="{{refundInfo}}">
      <text class="refund-content title">{{refundInfo.passenger_name}}</text>
      <view class="refund-content title">{{refundInfo.from_station_name }} 
      <es-icon class="arrow-right-icon" name="arrow-switch-right" color="#666666" size='20' />
      {{ refundInfo.to_station_name}}  {{refundInfo.train_code}}</view>
      <text class="refund-content sub-title">{{startTime}}</text>
       <text wx:if="{{showReason}}" class="refund-content-reason">退票原因:{{refundInfo.reason}}</text>
    </view>
  </view>
  

</view>
 
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { formatDate } from '@/utils/baseDate'

  createComponent({
    props: {
      refundInfo: Object,
      showReason: {
        type: Boolean,
        value: true
      }
    },
    data() {},
    computed: {
      startTime() {
        return formatDate(
          this.refundInfo?.start_time * 1000,
          'YYYY年MM月dd日 hh:mm'
        )
      }
    },
    methods: {},
    beforeCreate() {},

    created() {},

    mounted() {},

    destroyed() {}
  })
</script>

<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'

  .card-main
    border-radius 8px
    padding 16px 15px
    display flex
    flex-direction row
    color $train-color-333
    justify-content space-between
  .refund
    display flex
    flex-direction row
  .refund-info
    display flex
    flex-direction column
    margin-left 8px
    width calc(100vw - 90px)
  .refund-content
    font-family PingFangSC
    margin-bottom 2px
    display flex
    flex-direction row
    &.title
      font-size 15px
      font-weight 500
    &.sub-title
      font-size 12px
      font-weight 300
      color $train-color-666
    &-reason
      font-size 12px
      font-weight 300
      color $train-color-999
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      margin-right 20px
  .refund-detail
    display flex
    flex-direction row
    font-size 13px
    line-height 15px
    color $train-color-theme-blue
  .img
    flex 0 0 18px
    margin-top 1px
    width 18px
    height 18px
  .arrow-right-icon
    margin 0px 4px
</style>

<script name='json'>
  module.exports = {
    component: true
  }
</script>
